export type FunnelEvent = {
  funnel_elapsed_since_last_ms: number
  funnel_event_type: 'route_transition'
  funnel_route_from_page: string
  funnel_route_to_page: string
  funnel_route_transition_id: string
  funnel_sequence_num: number
  funnel_session_id: string
}

export const FUNNEL_EVENT_TYPE = 'route_transition' as const
export const NEW_SESSION_FROM = '__new__' as const
